export default "__VITE_ASSET__DkitjIOg__"